import { ACHIEVEMENT, DOCUMENTS, GLOBE, GROUP, INNOVATION } from "../../assets/icons";
import { ABOUTBANNER } from "../../assets/images";
import FindTutor from "../../components/Landing/FindTutor";
import Footer from "../../components/Landing/Footer";
import GetApp from "../../components/Landing/GetApp";
import TutorOpportunity from "../../components/Landing/TutorOpportunity";
import { SEO } from "../../components/SEO";

export default function About() {

  return (
    <>
    <SEO 
      title="About Us - WorldoTutor Story & Mission"
      description="Learn about WorldoTutor's mission to provide quality education worldwide. Discover our story, values, and commitment to one-on-one tutoring."
      keywords="about us, worldotutor, online tutoring company, education platform, tutoring mission"
      url="/about"
      type="website"
      og={{
        type: 'website',
        siteName: 'WorldoTutor',
        locale: 'en_US',
        image: {
          url: '/imgi_1_favicon.png',
          alt: 'About WorldoTutor - Online Tutoring Platform',
          width: 1200,
          height: 630
        }
      }}
      twitter={{
        card: 'summary_large_image',
        site: '@worldotutor',
        image: {
          url: '/imgi_1_favicon.png',
          alt: 'About WorldoTutor - Online Tutoring Platform'
        }
      }}
    />
    <div className="flex flex-col">
      <div className="relative h-full flex bg-primary items-center justify-center">
        <div className="relative h-full container mx-auto flex items-center justify-center">
          <div className="max-w-[600px] flex flex-col gap-y-6 z-20">
            <h1 className="text-4xl font-normal text-white">World O Tutor</h1>
            <p className="text-base font-normal text-white">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate.</p>
          </div>
          <div className="right-0 top-0 h-1/2 z-10">
            <img src={ABOUTBANNER} className="w-full h-full object-cover" />
          </div>
        </div>
      </div>

      <div className="flex flex-col container mx-auto bg-white p-10 gap-10 shadow-2xl my-10">
        <h1 className="text-4xl text-black font-medium text-center">The story and values behind <br /> our company</h1>
        <div className="w-full grid grid-rows-2 grid-cols-2 gap-14 items-center justify-center">
          <div className="w-full shrink-0">
            <div className="flex flex-row gap-6">
              <div className="shrink-0 w-20 h-20 bg-secondary rounded-full p-4 flex items-center justify-center">
                <img src={INNOVATION} className="w-1/2" />
              </div>
              <div className="flex flex-col gap-2">
                <h1 className="text-neutralGray1 font-bold">Innovation</h1>
                <p className="text-neutralGray2 text-base">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
              </div>
            </div>
          </div>
          <div className="w-full shrink-0">
            <div className="flex flex-row gap-6">
              <div className="shrink-0 w-20 h-20 bg-secondary rounded-full p-4 flex items-center justify-center">
                <img src={GROUP} className="w-1/2" />
              </div>
              <div className="flex flex-col gap-2">
                <h1 className="text-neutralGray1 font-bold">Team Work</h1>
                <p className="text-neutralGray2 text-base">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
              </div>
            </div>
          </div>
          <div className="w-full shrink-0">
            <div className="flex flex-row gap-6">
              <div className="shrink-0 w-20 h-20 bg-secondary rounded-full p-4 flex items-center justify-center">
                <img src={ACHIEVEMENT} className="w-1/2" />
              </div>
              <div className="flex flex-col gap-2">
                <h1 className="text-neutralGray1 font-bold">Excellence</h1>
                <p className="text-neutralGray2 text-base">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
              </div>
            </div>
          </div>
          <div className="w-full shrink-0">
            <div className="flex flex-row gap-6">
              <div className="shrink-0 w-20 h-20 bg-secondary rounded-full p-4 flex items-center justify-center">
                <img src={DOCUMENTS} className="w-1/2" />
              </div>
              <div className="flex flex-col gap-2">
                <h1 className="text-neutralGray1 font-bold">Responsibility</h1>
                <p className="text-neutralGray2 text-base">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="bg-primary my-10" >
        <FindTutor />
      </div>
      <div className="flex flex-col container mx-auto bg-white p-10 gap-10 shadow-2xl my-10">
        <h1 className="text-4xl text-black font-medium text-center">The story and values behind <br /> our company</h1>
        <div className="flex">
          <div className="w-1/2 flex flex-col pl-48 justify-around">
            <div className="relative flex flex-col">
              <div className="absolute z-10 -left-24">
                <h1 className="text-neutralBlue2 text-[108px] font-bold leading-[80px]">100+</h1>
              </div>
              <h3 className="max-w-[300px] text-3xl text-neutralGray1 font-semibold z-20">Used in 10+ countries around the world</h3>
            </div>

            <div className="relative flex flex-col">
              <div className="absolute z-10 -left-24">
                <h1 className="text-neutralBlue2 text-[108px] font-bold leading-[80px]">700+</h1>
              </div>
              <h3 className="max-w-[300px] text-3xl text-neutralGray1 font-semibold z-20">Over 700+ members</h3>
            </div>
          </div>
          <div className="w-1/2">
            <img src={GLOBE} className="w-full object-contain max-h-[500px]" />
          </div>
        </div>
      </div>
      <div className="bg-primary my-10">
        <TutorOpportunity />
      </div>
      <GetApp />
      <div className="bg-neutralBlack" id="footer">
        <Footer />
      </div>
    </div>
    </>
  )
}